module.exports = "/images/image4.jpg?ba20b7871eabd2318fd57c61a2acbb48";